import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  return (
    <section className="py-20 lg:py-32 bg-gradient-to-br from-primary via-primary to-accent relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-white rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-white rounded-full blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-6 lg:px-8 relative z-10">
        <div className="text-center text-white">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/20 backdrop-blur-sm text-white text-sm font-medium mb-6">
            <Icon name="Rocket" size={16} className="mr-2" />
            Ready to Get Started?
          </div>
          
          <h2 className="text-3xl lg:text-6xl font-bold mb-6 leading-tight">
            Join the Future of
            <span className="block">Fair Recruitment</span>
          </h2>
          
          <p className="text-xl lg:text-2xl text-white/90 mb-12 max-w-4xl mx-auto leading-relaxed">
            Whether you're looking for your next opportunity or searching for exceptional talent, 
            Workfolio connects the right people based on what truly matters: skills and potential.
          </p>
          
          {/* Dual CTA */}
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-16">
            {/* Job Seeker CTA */}
            <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 border border-white/20 hover:bg-white/15 transition-all duration-300 group">
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <Icon name="User" size={32} className="text-white" />
              </div>
              
              <h3 className="text-2xl font-bold text-white mb-4">
                For Job Seekers
              </h3>
              
              <p className="text-white/80 mb-6 leading-relaxed">
                Create your anonymous profile for free and get discovered by top employers 
                who value your skills over your background.
              </p>
              
              <Button 
                variant="secondary" 
                size="lg" 
                fullWidth 
                asChild
                className="bg-white text-primary hover:bg-white/90"
              >
                <Link to="/job-seeker-registration">
                  <Icon name="UserPlus" size={20} className="mr-2" />
                  Create Free Profile
                </Link>
              </Button>
              
              <div className="flex items-center justify-center space-x-4 mt-4 text-sm text-white/70">
                <div className="flex items-center">
                  <Icon name="Check" size={16} className="mr-1" />
                  100% Free
                </div>
                <div className="flex items-center">
                  <Icon name="Shield" size={16} className="mr-1" />
                  Anonymous
                </div>
                <div className="flex items-center">
                  <Icon name="Zap" size={16} className="mr-1" />
                  Instant Setup
                </div>
              </div>
            </div>
            
            {/* Employer CTA */}
            <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 border border-white/20 hover:bg-white/15 transition-all duration-300 group">
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <Icon name="Building2" size={32} className="text-white" />
              </div>
              
              <h3 className="text-2xl font-bold text-white mb-4">
                For Employers
              </h3>
              
              <p className="text-white/80 mb-6 leading-relaxed">
                Search thousands of qualified candidates for free. Pay only 149 NOK 
                when you find someone worth contacting.
              </p>
              
              <Button 
                variant="secondary" 
                size="lg" 
                fullWidth 
                asChild
                className="bg-white text-primary hover:bg-white/90"
              >
                <Link to="/employer-registration">
                  <Icon name="Search" size={20} className="mr-2" />
                  Start Searching
                </Link>
              </Button>
              
              <div className="flex items-center justify-center space-x-4 mt-4 text-sm text-white/70">
                <div className="flex items-center">
                  <Icon name="Search" size={16} className="mr-1" />
                  Free Search
                </div>
                <div className="flex items-center">
                  <Icon name="CreditCard" size={16} className="mr-1" />
                  Pay Per Unlock
                </div>
                <div className="flex items-center">
                  <Icon name="Users" size={16} className="mr-1" />
                  Quality Talent
                </div>
              </div>
            </div>
          </div>
          
          {/* Stats */}
          <div className="grid md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="text-3xl lg:text-4xl font-bold text-white mb-2">2,500+</div>
              <div className="text-white/80">Active Job Seekers</div>
            </div>
            <div className="text-center">
              <div className="text-3xl lg:text-4xl font-bold text-white mb-2">500+</div>
              <div className="text-white/80">Trusted Companies</div>
            </div>
            <div className="text-center">
              <div className="text-3xl lg:text-4xl font-bold text-white mb-2">85%</div>
              <div className="text-white/80">Success Rate</div>
            </div>
            <div className="text-center">
              <div className="text-3xl lg:text-4xl font-bold text-white mb-2">40%</div>
              <div className="text-white/80">More Diverse Hires</div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1200 120" className="w-full h-12 fill-background">
          <path d="M0,60 C300,120 900,0 1200,60 L1200,120 L0,120 Z"></path>
        </svg>
      </div>
    </section>
  );
};

export default CTASection;